import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TokenAutorizacaoValidacaoComponent} from './token-autorizacao-validacao.component';
import {MaxNgLibModule} from 'max-ng-lib';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';


@NgModule({
  declarations: [
    TokenAutorizacaoValidacaoComponent
  ],
  imports: [
    CommonModule,
    MaxNgLibModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [
    TokenAutorizacaoValidacaoComponent
  ]
})
export class TokenAutorizacaoValidacaoModule {
}
